import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navigationItems } from '../../data/navigation';

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState('');
  const closeTimerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
    setOpenDropdown('');
  }, [location.pathname]);

  useEffect(
    () => () => {
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
      }
    },
    []
  );

  const openMenu = (label) => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
    }
    setOpenDropdown(label);
  };

  const closeMenu = () => {
    closeTimerRef.current = setTimeout(() => {
      setOpenDropdown('');
    }, 180);
  };

  const isGroupActive = (item) =>
    item.children?.some((child) => location.pathname === child.path) || false;

  return (
    <header className="site-header">
      <div className="container nav-shell">
        <Link className="brand" to="/" aria-label="FactorStreet home">
          <img className="brand-logo" src="/fs_r_192px.png" alt="" aria-hidden="true" />
          <span>Factor Street</span>
        </Link>

        <button
          aria-expanded={isOpen}
          aria-label="Toggle navigation menu"
          className="menu-toggle"
          onClick={() => setIsOpen((current) => !current)}
          type="button"
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`primary-nav ${isOpen ? 'is-open' : ''}`} aria-label="Primary navigation">
          {navigationItems.map((item) => {
            if (!item.children) {
              return (
                <NavLink
                  className={({ isActive }) => `nav-link ${isActive ? 'is-active' : ''}`}
                  key={item.path}
                  to={item.path}
                >
                  {item.label}
                </NavLink>
              );
            }

            const dropdownActive = openDropdown === item.label;
            return (
              <div
                className={`nav-dropdown ${isGroupActive(item) ? 'is-active' : ''} ${
                  dropdownActive ? 'is-open' : ''
                }`}
                key={item.label}
                onMouseEnter={() => openMenu(item.label)}
                onMouseLeave={closeMenu}
              >
                <button
                  aria-expanded={dropdownActive}
                  className="nav-link nav-dropdown__toggle"
                  onClick={() =>
                    setOpenDropdown((current) => (current === item.label ? '' : item.label))
                  }
                  type="button"
                >
                  {item.label}
                  <span aria-hidden="true">▾</span>
                </button>

                <div className="nav-dropdown__menu">
                  {item.children.map((child) => (
                    <NavLink
                      className={({ isActive }) =>
                        `nav-dropdown__item ${isActive ? 'is-active' : ''}`
                      }
                      key={child.path}
                      to={child.path}
                    >
                      {child.label}
                    </NavLink>
                  ))}
                </div>
              </div>
            );
          })}
        </nav>
      </div>
    </header>
  );
}

export default Header;
